import { Component, inject, signal, computed, Renderer2, DOCUMENT } from '@angular/core';

import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { of } from 'rxjs';
import { hapticTap } from '../shared/haptics.util';
import { AuthService } from '../services/auth.service';
import { NotificacionService } from '../services/notificacion.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    standalone: false
})
export class NavbarComponent {
  private router = inject(Router);
  private _authService = inject(AuthService);
  readonly _notificacionService = inject(NotificacionService);

  private renderer = inject(Renderer2);
  private document = inject(DOCUMENT);

  // === estado ===
  modalOpen   = signal(false);
  showPrestador = signal(false);
  showComercio  = signal(false);
  showEmergency = signal(false);

  // iOS Safari: clase para ajustes visuales
  isIOS = computed(() => Capacitor.getPlatform() === 'ios');

  // logged según Firebase
  readonly isLogged = this._authService.isLoggedIn;

  // notificaciones no leídas (convierte observable a signal)
  hasNewNotification = toSignal(
  this._notificacionService.isNewNotification ?? of(false),
    { initialValue: false }
  );

  // === helpers ===
  isActiveAccount = (url: string) => this.router.url.startsWith(url);

  private setBodyBlur(active: boolean) {
    const cls = 'blur-app';
    if (active) {
      this.renderer.addClass(this.document.body, cls);
    } else {
      this.renderer.removeClass(this.document.body, cls);
    }
  }

  // === acciones ===
  openmodal() {
    const open = !this.modalOpen();
    this.modalOpen.set(open);
    this.showPrestador.set(open);
    this.showComercio.set(open);
    this.showEmergency.set(open);
    this.setBodyBlur(open); 
    if (open) hapticTap(); 
  }

  hidemenu() {
    this.modalOpen.set(false);
    this.showPrestador.set(false);
    this.showComercio.set(false);
    this.showEmergency.set(false);
    this.setBodyBlur(false); 
    hapticTap();
  }

  turnos() {
    this.hidemenu();
    hapticTap();
    this.router.navigate(['/especialidad']);
    document.documentElement.scrollTop = 0;
  }

  pedidos() {
    this.hidemenu();
    hapticTap();
    this.router.navigate(['/comercio']);
    document.documentElement.scrollTop = 0;
  }

  emergencias() {
    this.hidemenu();
    hapticTap();
    this.router.navigate(['/order-emergencias']);
    document.documentElement.scrollTop = 0;
  }
}
